import { BrowserRouter, HashRouter } from "react-router-dom";
import Routing from "./routes/Routing";
import "./css/style.css";
import { AxiosInterceptor } from "./config/axiosInstance";
import "react-phone-input-2/lib/bootstrap.css";
import { Provider } from "react-redux";
import appStore from "./utils/store/appStore";
import { CountTrackingProvider } from "./context/CountTrackingContext";

function App() {
  return (
    <>
      {/* <HashRouter> */}
        <BrowserRouter>
        <Provider store={appStore}>
          <CountTrackingProvider 
            options={{
              refreshInterval: 30000, // 30 seconds
              autoRefresh: true,
              trackMenuClicks: true
            }}
          >
            <AxiosInterceptor>
              <Routing />
            </AxiosInterceptor>
          </CountTrackingProvider>
        </Provider>
        </BrowserRouter>
      {/* </HashRouter> */}
    </>
  );
}

export default App;
